import { Component } from '@angular/core';

import { AuthenticatorService } from '@aws-amplify/ui-angular';

@Component({
  selector: 'app-logged-out-menu',
  templateUrl: './logged-out-menu.component.html',
  styleUrls: ['./logged-out-menu.component.scss'],
})
export class LoggedOutMenuComponent {
  constructor(public authenticatorService: AuthenticatorService) {}
}
